import { createContext, useState, useContext, ReactNode } from 'react';
import { IBudgetProps } from '../hooks/reactQuery/useBudgets/types';

type TempSaleData = IBudgetProps;

interface SaleContextData {
  tempSaleData: TempSaleData | null;
  setTempSaleData: (data: TempSaleData | null) => void;
}

export const SaleContext = createContext<SaleContextData>({
  tempSaleData: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setTempSaleData: () => {},
});

type SaleProviderProps = {
  children: ReactNode;
};

export function SaleProvider({ children }: SaleProviderProps) {
  const [tempSaleData, setTempSaleData] = useState<TempSaleData | null>(null);

  console.log('aqui dentro do proviuder sale', tempSaleData);

  return (
    <SaleContext.Provider value={{ tempSaleData, setTempSaleData }}>
      {children}
    </SaleContext.Provider>
  );
}

export const useSale = () => useContext(SaleContext);
